import { Component, DesignerInterface } from "../../..";
import { Panel } from "../../panel/Panel";
import { PanelProps } from "../../panel/PanelProps";
import { Table } from "../../table/Table";

export abstract class AbstractTableToolsPanel extends Panel {
    protected readonly table: Table;

    constructor(table: Table, props?: Partial<PanelProps>) {
        super({
            wrap: false,
            rowBreak: false,
            rowBreakDefault: false,
            padding: 0,
            _designer: table._designer,
            ...props
        });
        this.table = table;
    }

    rowSelectionChanged() {
    }

    override add(...components: Component[]): Component {
        components?.forEach(component => component._designer = this.table._designer);
        const result = super.add(...components);
        this.evaluatePadding();
        return result;
    }

    override relayout() {
        super.relayout();
        this.evaluatePadding();
    }

    private evaluatePadding() {
        if (this.isEmpty())
            this.padding = 0;
        else {
            this.paddingLeft = this.getPopulatedPaddingLeft();
            this.paddingRight = this.getPopulatedPaddingRight();
            this.paddingTop = 0;
            this.paddingBottom = 0;
        }
    }

    abstract getPopulatedPaddingLeft(): number;
    abstract getPopulatedPaddingRight(): number;

    override get _designer(): DesignerInterface {
        return super._designer;
    }

    override set _designer(value: DesignerInterface) {
        super._designer = value;
        this.components.forEach(component => component._designer = value);
    }
}
